import { useAtomValue } from 'jotai/index';
import { useMemo } from 'react';
import { InstrumentStore, InstrumentStoreItem, InstrumentSubscriptionDataScope, ListedInstrument } from '../../types';
import { useInstrumentSubscription } from './useInstrumentSubscription';
import { SubscribeToInstrumentChangesFn } from './useSubscribeToInstrumentChanges';

export type InstrumentSubscriptionProps = {
  source: string;
  disableSubscription?: boolean;
  dataScope?: Array<InstrumentSubscriptionDataScope>;
  forceRequestStaticData?: boolean;
};

/**
 * Get the instrument store item for a given instrument.
 */
export const useInstrumentStoreItem = (
  instrument: ListedInstrument | null,
  instrumentStore: InstrumentStore,
  subscribeToInstrumentChanges: SubscribeToInstrumentChangesFn,
  subscriptionParams?: InstrumentSubscriptionProps,
) => {
  const instrumentAtom = useInstrumentSubscription(
    instrument,
    instrumentStore,
    subscribeToInstrumentChanges,
    subscriptionParams,
  );
  const instrumentStoreItem = useAtomValue(instrumentAtom);

  return useMemo(() => instrumentStoreItem as InstrumentStoreItem | undefined, [instrumentStoreItem]);
};
